import { NewsletterViewApiType } from 'modules/newsletters/single/types/newsletter-view-interface'
import { TagListAllInterface } from 'modules/tags/types/tag-interface'
import { ContactsSettings } from 'shared/components/dashboard-mail-editor/components/contacts-settings-block'
import {
  AttachmentFileInterface,
  UnsavedAttachmentFileInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'
import { TempStateType } from 'shared/components/dashboard-mail-editor/types/temp-state-type'
import { isAttachmentInterface } from 'shared/components/dashboard-mail-editor/utils/is-attachment-interface'

export const transformToNewsletterData = ({
  attachmentsTempState,
  tempState,
  contactsSettings,
  newsletterData,
  listOfTags,
}: {
  attachmentsTempState: Array<UnsavedAttachmentFileInterface | AttachmentFileInterface>
  tempState: TempStateType
  contactsSettings: ContactsSettings
  listOfTags: TagListAllInterface | undefined
  newsletterData: NewsletterViewApiType
}): NewsletterViewApiType => {
  return {
    ...newsletterData,
    mailing: {
      ...newsletterData.mailing,
      currentEmail: {
        ...newsletterData.mailing.currentEmail,
        ...tempState,
        attachments: attachmentsTempState.filter(isAttachmentInterface),
      },
    },
    tags: listOfTags?.items.filter(el => contactsSettings.tags.included.includes(el.id)) ?? [],
    excludedTags:
      listOfTags?.items.filter(el => contactsSettings.tags.excluded.includes(el.id)) ?? [],
    daysExists: contactsSettings.daysExists,
  }
}
